var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSeniorMandF = function SvgSeniorMandF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0c19.325 0 34.997 15.672 34.997 34.996 0 19.325-15.672 34.997-34.997 34.997C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#5B9FFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 0v69.993C15.672 69.993 0 54.32 0 34.996 0 15.672 15.672 0 34.996 0Z",
    fill: "#0F68EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.858 66.125c-.54.23-1.107.446-1.697.647l.244-5.737c.274-6.441.151-6.297.87 0l.583 5.09Z",
    fill: "#AFC6D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.003 29C26.688 29 24 33.25 24 38.5s2.688 9.5 6.003 9.5S36 43.75 36 38.5 33.312 29 30.003 29Z",
    fill: "#CBCCCC"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.296 34.313 3.314.202c2.71 0 5.341-.036 8.073-.202l.568 4.149c.295 2.156.956 3.623 3.3 3.918 5.916.747 9.583 1.696 12.178 5.384 1.999 2.833 3.666 7.146 3.178 10.582a10.583 10.583 0 0 1-.36 1.625c-5.744 5.658-13.429 9.346-21.97 9.971a62.478 62.478 0 0 1-5.19 0c-8.534-.625-16.219-4.313-21.956-9.97a11.507 11.507 0 0 1-.36-1.626c-.488-3.436 1.18-7.75 3.178-10.582 2.603-3.688 6.27-4.637 12.186-5.384 2.344-.295 3.005-1.769 3.3-3.918l.56-4.149Z",
    fill: "#E7C09A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.783 40.259c.438 1.208 1.107 1.905 2.76 2.113 5.917.748 9.584 1.697 12.179 5.385 1.998 2.833 3.666 7.146 3.177 10.582a10.594 10.594 0 0 1-.359 1.625c-5.744 5.658-13.43 9.346-21.963 9.971a62.565 62.565 0 0 1-5.19 0c-8.534-.625-16.219-4.32-21.956-9.971a11.505 11.505 0 0 1-.36-1.625c-.488-3.436 1.18-7.75 3.178-10.582 2.603-3.688 6.27-4.637 12.186-5.385 1.495-.194 2.3-.855 2.775-1.869l6.707 15.636 6.873-15.887-.007.007Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.42 42.487c5.407.74 8.843 1.769 11.309 5.27 1.999 2.833 3.666 7.146 3.178 10.582a10.582 10.582 0 0 1-.36 1.625c-5.744 5.658-13.429 9.346-21.962 9.971a62.478 62.478 0 0 1-5.191 0c-8.533-.625-16.218-4.32-21.955-9.971a11.505 11.505 0 0 1-.36-1.625c-.489-3.436 1.18-7.75 3.178-10.582 2.494-3.537 5.967-4.55 11.46-5.291l6.361 20.64 3.904 6.844 3.746-6.722L45.42 42.48v.007Z",
    fill: "#00EEC8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.094 66.226-.23-5.198c-.28-6.441-.15-6.298-.891 0l-.503 4.306c.532.31 1.07.604 1.624.885v.007Z",
    fill: "#AFC6D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.974 41.883 2.236-1.732 4.903 11.747-7.16-1.294.021-8.72Z",
    fill: "#A9E0F6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m43.875 41.883-2.229-1.732-4.91 11.747 7.168-1.294-.029-8.72Z",
    fill: "#fff"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.017 51.826-4.63-1.704-2.545-6.815 6.269-1.424 8.871 28.067-9.856-16.097 1.89-2.027Z",
    fill: "#F7FCFE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m42.97 51.826 4.629-1.704 2.538-6.815-6.262-1.424-8.871 28.067 9.856-16.097-1.89-2.027Z",
    fill: "#C8FBEE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.855 60.626h8.562v5.83l-.093.05h-8.47v-5.88Z",
    fill: "#EDFEF9"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.413 61.258h1.445v1.625h1.625v1.416h-1.625v1.625h-1.445v-1.625H43.79v-1.416h1.624v-1.625Z",
    fill: "#118080"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m29.296 34.313 3.314.202c.798 0 1.589 0 2.38-.015v35.493c-.87 0-1.74-.022-2.603-.058-8.534-.625-16.219-4.313-21.956-9.97a11.507 11.507 0 0 1-.36-1.626c-.488-3.436 1.18-7.75 3.178-10.582 2.603-3.688 6.27-4.637 12.186-5.385 2.344-.294 3.005-1.768 3.3-3.918l.56-4.148v.008Z",
    fill: "#E5B085"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 69.993c-.87 0-1.74-.022-2.602-.05-8.533-.626-16.218-4.321-21.955-9.972a11.505 11.505 0 0 1-.36-1.624c-.489-3.437 1.18-7.75 3.178-10.583 2.602-3.688 6.269-4.637 12.185-5.385 1.495-.194 2.3-.855 2.775-1.869l6.708 15.637.079-.187V70l-.008-.007Z",
    fill: "#CCE1EC"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 69.993c-.87 0-1.74-.022-2.602-.05-8.533-.626-16.218-4.321-21.955-9.972a11.505 11.505 0 0 1-.36-1.624c-.489-3.437 1.18-7.75 3.178-10.583 2.494-3.537 5.967-4.55 11.46-5.291l6.361 20.64 3.904 6.844v-.022l.007.058h.008Z",
    fill: "#00CBAB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.094 66.226-.23-5.198c-.28-6.441-.15-6.298-.891 0l-.503 4.306c.532.31 1.07.604 1.624.885v.007Z",
    fill: "#2F9291"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m25.974 41.883 2.236-1.732 4.903 11.747-7.16-1.294.021-8.72Z",
    fill: "#CCE1EC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m27.017 51.826-4.63-1.704-2.545-6.815 6.269-1.424 8.871 28.067-9.856-16.097 1.89-2.027Z",
    fill: "#34F0CE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.255 25.104c-.216-.273-.51-.388-.827-.402.057-.655.1-1.316.1-1.977.036-6.514-2.667-10.748-7.153-12.15a11 11 0 0 0-6.686.029c-4.42 1.423-7.232 5.622-7.232 12.12 0 .662.036 1.323.094 1.978-.31.021-.604.129-.82.402-.669.834-.374 2.631.28 3.911.238.467.525.87.95 1.172.287.208.61.345.848.237 1.179 3.235 3.084 5.967 5.5 7.577 2.882 1.927 4.615 1.898 7.483-.079 2.358-1.624 4.213-4.32 5.37-7.505.238.122.568-.022.87-.237.425-.302.712-.705.95-1.172.646-1.28.941-3.084.273-3.911v.007Z",
    fill: "#FBDEC2"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.996 10.072a10.86 10.86 0 0 0-3.307.532c-4.42 1.423-7.232 5.622-7.232 12.12 0 .662.036 1.323.094 1.978-.31.021-.604.129-.82.402-.669.834-.374 2.631.28 3.911.238.467.525.87.95 1.172.287.208.61.345.848.237 1.179 3.235 3.084 5.967 5.5 7.577 1.416.95 2.552 1.417 3.68 1.424v-29.36l.007.007Z",
    fill: "#E9C5A0"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.594 25.248a17.583 17.583 0 0 1-.913-5.579c0-5.866 3.012-9.662 7.764-10.942A14.03 14.03 0 0 1 38.62 8.7c4.816 1.265 7.72 5.09 7.678 10.97a17.954 17.954 0 0 1-.92 5.543c.021-.18.035-.36.057-.54-1.575-4.406-5.658-7.555-10.446-7.555-4.788 0-8.878 3.149-10.453 7.57.015.187.036.374.058.554v.007Zm20.884-1.078c.007-.151.022-.302.029-.453 0 .15-.015.302-.029.453Zm.036-.712c0-.122 0-.244.007-.367 0 .122 0 .245-.007.367Z",
    fill: "#EAEAEA"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.148 15.579h21.69c.187.747.33 1.553.438 2.365h-22.56c.101-.812.252-1.61.44-2.365h-.008Z",
    fill: "#565759"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.594 25.248a17.583 17.583 0 0 1-.913-5.579c0-5.866 3.012-9.662 7.764-10.941a13.775 13.775 0 0 1 3.551-.482v8.878c-4.788 0-8.878 3.15-10.453 7.57.015.187.036.374.058.554h-.007Z",
    fill: "#CBCCCC"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.148 15.579H34.99v2.365H23.71c.101-.812.252-1.61.44-2.365Z",
    fill: "#565759"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 11.416c2.977 0 5.392 2.444 5.392 5.464 0 3.02-2.415 5.464-5.391 5.464-2.977 0-5.392-2.452-5.392-5.464 0-3.012 2.415-5.464 5.392-5.464Z",
    fill: "#9A9CA0"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 11.416h.21v10.92h-.21c-2.976 0-5.391-2.451-5.391-5.463 0-3.013 2.415-5.464 5.392-5.464v.007Z",
    fill: "#848689"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 15.428c.791 0 1.438.654 1.438 1.46 0 .804-.647 1.458-1.437 1.458-.791 0-1.438-.654-1.438-1.459s.647-1.46 1.438-1.46Z",
    fill: "#393839"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.78 15.428c.073 0 .145 0 .21.014v2.883c-.073.007-.137.014-.21.014a1.447 1.447 0 0 1-1.437-1.46c0-.804.647-1.459 1.438-1.459v.008Z",
    fill: "#393839"
  })));
};
export default SvgSeniorMandF;